import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useMobileThemeContext } from '../context/MobileThemeProvider';

export default function MobileThemeToggle() {
  const { mode, toggleMode } = useMobileThemeContext();
  const isDark = mode === 'dark';

  return (
    <Tooltip title={isDark ? 'Vaalea teema' : 'Tumma teema'}>
      <IconButton
        onClick={toggleMode}
        aria-label={isDark ? 'Vaihda vaaleaan teemaan' : 'Vaihda tummaan teemaan'}
        sx={{ minWidth: 48, minHeight: 48 }}
      >
        {isDark ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
      </IconButton>
    </Tooltip>
  );
}
